<template>
  <div
    v-if="showBanner"
    class="border border-bubblegum-200 bg-bubblegum-50 rounded-lg p-4 space-y-2 md:flex md:items-center md:space-y-0 md:space-x-4"
  >
    <div class="flex">
      <vetster-plus-badge />
    </div>
    <p
      v-if="showFleaAndTickDiscount"
      class="text-neutral-900"
      v-html="fleaAndTickBenefit"
    />
    <p
      v-else-if="hasMembershipWithRemainingAppointments"
      class="text-neutral-900 text-sm font-medium"
      v-html="$t('membership-subscriptions.your-appointments-are-included-html', { plan: getPlanName })"
    />
    <div v-else>
      <p class="font-semibold">
        {{ $t('membership-subscriptions.enjoy-percent-off-appointments', { percent: getCoinsurancePercentage }) }}
      </p>
      <p>{{ $t('membership-subscriptions.with-your-plan-a-discount', { plan: getPlanName }) }}</p>
    </div>
  </div>
</template>

<script>
import { getCurrentInstance } from 'vue';
import { mapGetters } from 'vuex';

import VetsterPlusBadge from '@/brand-components/VetsterPlusBadge';
import useSubscriptionHelpers from '@/composables/use-subscription-helpers';

export default {
  name: 'VetsterPlusBenefitsBanner',

  components: { VetsterPlusBadge },

  setup() {
    const root = getCurrentInstance().proxy.$root;
    const {
      fleaAndTickDiscount,
      hasFleaAndTickDiscount,
    } = useSubscriptionHelpers(root);

    return {
      fleaAndTickDiscount,
      hasFleaAndTickDiscount,
    };
  },

  computed: {
    ...mapGetters(['isEcommerceCapable']),
    ...mapGetters('search', ['getSearchPet']),
    ...mapGetters('subscriptions', [
      'getCoinsurancePercentage',
      'getIndividualSubscription',
      'hasMembershipSubscription',
      'remainingAppointmentsCount',
    ]),
    fleaAndTickBenefit() {
      const key = this.hasMembershipSubscription
        ? 'membership-subscriptions.flea-and-tick-discount-subscriber-html'
        : 'membership-subscriptions.flea-and-tick-discount-non-subscriber-html';

      return this.$t(key, { discount: this.fleaAndTickDiscount });
    },
    getPlanName() {
      return this.getIndividualSubscription?.name;
    },
    hasMembershipWithRemainingAppointments() {
      return this.remainingAppointmentsCount > 0
        || (this.remainingAppointmentsCount === -1 && this.searchPetIsCovered);
    },
    searchPetIsCovered() {
      return this.getIndividualSubscription?.pets?.findIndex((pet) => pet.uuid === this.getSearchPet) !== -1;
    },
    showBanner() {
      return this.hasMembershipWithRemainingAppointments || this.getCoinsurancePercentage || this.showFleaAndTickDiscount;
    },
    showFleaAndTickDiscount() {
      return this.hasFleaAndTickDiscount && this.isEcommerceCapable;
    },
  },
};
</script>
